import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import loading from './modules/loading'
import menuStore from "./modules/menuStore";
import tagsView from './modules/tagsView';

import getters from './getters'

// 必须要重新引用一下。
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    loading,
    menuStore,
    tagsView,
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js